var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#B2D235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.6C12.9942 9.6 13.8001 8.79411 13.8001 7.8C13.8001 6.80589 12.9942 6 12.0001 6C11.006 6 10.2001 6.80589 10.2001 7.8C10.2001 8.79411 11.006 9.6 12.0001 9.6Z",
    fill: "#B2D235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 10.7998H12H6.40003C6.00003 10.7998 5.84003 11.2998 6.18003 11.5198L9.10003 13.3998C9.24003 13.4998 9.32003 13.6798 9.26003 13.8398L8.16003 17.4998C8.04003 17.8998 8.56003 18.1798 8.86003 17.8798L11.7 14.8798C11.86 14.6998 12.14 14.6998 12.3 14.8798L15.14 17.8798C15.42 18.1798 15.94 17.8998 15.84 17.4998L14.74 13.8398C14.7 13.6798 14.76 13.4998 14.9 13.3998L17.82 11.5198C18.16 11.2998 18 10.7998 17.6 10.7998Z",
    fill: "#B2D235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.a448d9c4f83f2bc8ffd634f5c81c629f.svg";
export { ForwardRef as ReactComponent };